import { Activity } from "../entities/interfaces/actviity";
import Api, { ApiResponse } from "../utils/axios";

export const list = async (): Promise<ApiResponse<Activity[]>> => {
  return await Api.get("/activity");
};

// export const create = async (
//   createServiceDto: CreateServiceDto
// ): Promise<ApiResponse<Service[]>> => {
//   return await Api.post("/services", createServiceDto);
// };

// export const update = async (
//   id: string,
//   updateServiceDto: UpdateServiceDto
// ): Promise<ApiResponse<Service[]>> => {
//   return await Api.patch(`/services/${id}`, updateServiceDto);
// };

const ActivityService = { list };
export default ActivityService;
